import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import { HelmetProvider } from "react-helmet-async";
const helmetContext = {};

import "./index.css";
import App from "./components/App/App";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./redux/store";
import { theme } from "./utils/mui";
import "./firebase";

const initialState = global.window && global.window.__INITIAL_STATE__;
const store = configureStore(initialState);

// Create emotion cache
const cache = createCache({ key: "css" });

// Suppress benign ResizeObserver errors
// This is a known issue with ResizeObserver that's safe to ignore
// See: https://github.com/WICG/resize-observer/issues/38
if (typeof window !== "undefined") {
  // Suppress console.error for ResizeObserver
  const resizeObserverErr = window.console.error;
  window.console.error = (...args) => {
    if (
      args[0] &&
      typeof args[0] === "string" &&
      args[0].includes("ResizeObserver loop")
    ) {
      // Suppress this specific error
      return;
    }
    resizeObserverErr(...args);
  };

  // Also suppress as uncaught error
  window.addEventListener("error", (e) => {
    if (
      e.message &&
      e.message.includes(
        "ResizeObserver loop completed with undelivered notifications"
      )
    ) {
      e.stopImmediatePropagation();
      return true; // Prevent default error handling
    }
  });
}

function Main() {
  // No cleanup needed for tss-react/Emotion
  // The styles are handled automatically by the Emotion cache

  return (
    <HelmetProvider context={helmetContext}>
      <CacheProvider value={cache}>
        <ThemeProvider theme={theme}>
          <App store={store} />
        </ThemeProvider>
      </CacheProvider>
    </HelmetProvider>
  );
}

ReactDOM.hydrate(<Main />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
